export function parseQrBookingData(decodedText) {
  const trimmed = decodedText?.trim();
  if (!trimmed) return null;

  try {
    const json = JSON.parse(trimmed);
    const bookingId =
      json.BookingID ??
      json.bookingId ??
      json.intBookingID ??
      json.PNR ??
      json.PNRNo ??
      json.pnr;
    const seatNos = normalizeSeatNos(
      json.SeatNos ?? json.seatNos ?? json.SeatNo ?? json.seatNo
    );

    if (bookingId) {
      return { bookingId: String(bookingId).split("-")[0], seatNos };
    }
  } catch {
    // Not JSON — continue with plain-text parsing.
  }

  const pnrMatch = trimmed.match(/PNR[-:\s]?([A-Za-z0-9-]+)/i);
  if (pnrMatch) {
    return {
      bookingId: pnrMatch[1].split("-")[0],
      seatNos: [],
    };
  }

  const numericMatch = trimmed.match(/(\d{6,})/);
  if (numericMatch) {
    return {
      bookingId: numericMatch[1],
      seatNos: [],
    };
  }

  return {
    bookingId: trimmed.split("-")[0],
    seatNos: [],
  };
}

function normalizeSeatNos(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.map(String);
  return String(value)
    .split(",")
    .map((seat) => seat.trim())
    .filter(Boolean);
}
